import { call, get } from 'vuex-pathify';

import { MVT } from 'ol/format';
import { VectorTile as VectorTileLayer } from 'ol/layer';
import { VectorTile as VectorTileSource } from 'ol/source';

import { defaultMvtSourceLoader } from '@/assets/js/mapUtils';

export default {
  computed: {
    tasksLayerId: get('admin/modulesMapping@tasks.layer_id'),
    tasksDataSource: get('admin/modulesMapping@tasks.datasource_name'),
    tasksLayer: get('layers/featuresLayers@:tasksLayerId'),
    tasksFeatures: get('layers/layersFeatures@:tasksLayerId'),
    layersFilters: get('layers/layersFilters'),
  },
  methods: {
    getLayerFeatures: call('layers/getLayerFeatures'),
    setCurrentStyle: call('styles/setCurrentStyle'),
    setDefaultStyle: call('styles/setDefaultStyle'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    setLoaded: call('modules/setLoaded'),
    async toggleTasks(value) {
      if (value) {
        await Promise.all([
          this.getFeaturesLayer(this.tasksLayerId),
          this.getLayerFeatures({ layer_id: this.tasksLayerId }),
        ]);
        this.addTasksLayer();
        this.toggleModuleIdentification({ isActive: true, moduleRoute: 'task' });
      } else {
        this.toggleModuleIdentification({ isActive: false, moduleRoute: '' });
        this.removeProjectLayers([this.tasksLayerId]);
        if (this.layersFilters[this.tasksLayerId]) {
          delete this.layersFilters[this.tasksLayerId];
        }
        this.setLoaded({ dataSource: this.tasksDataSource, value: false });
      }
    },
    toggleTasksFilter() {
      this.removeProjectLayers([this.tasksLayerId]);
      this.addTasksLayer();
    },
    addTasksLayer() {
      this.removeProjectLayers([this.tasksLayerId]);
      const { data_source_name, id, type, group_id, name } = this.tasksLayer;
      const style = JSON.parse(JSON.stringify(this.tasksLayer.style_web));

      this.mvtVisibleLayersCounter++;
      const styleAttributes = this.getRequiredAttributes(id, style);
      const mvtLayer = new VectorTileLayer({
        opacity: 1,
        data_source_name,
        id,
        type,
        group_id,
        name,
        isSpecial: true,
        visible: true,
        source: new VectorTileSource({
          format: new MVT(),
          url: `${process.env.VUE_APP_API_URL}/layers/features_layers/${id}/mvt/{z}/{x}/{y}`,
          projection: this.$_config.defaultEpsg,

          tileLoadFunction: tile => {
            defaultMvtSourceLoader(tile, id, {
              filters: this.layersFilters[this.tasksLayer.id]
                ? this.layersFilters[this.tasksLayer.id].filterExpression
                : {},
              styleAttributes,
            });
          },
        }),
        zIndex: 100,
        style: f => this.getFeatureStyle(f, style, this.tasksLayer.geometry_type, true, id),
        renderMode: 'image',
      });
      const defaultStyle = {
        datasource: this.tasksDataSource,
        name: this.$i18n.t('default.defaultStyle'),
        isDefault: true,
        style: style,
      };
      this.setCurrentStyle({ dataSource: this.tasksDataSource, style: defaultStyle });
      this.setDefaultStyle({ dataSource: this.tasksDataSource, style: defaultStyle });
      mvtLayer.getSource().once('tileloadend', () => {
        ++this.mvtVisibleLayersLoaded;
        this.identifyCoordinatesOnInit();
      });
      this.getLayerById('layers')
        .getLayers()
        .push(mvtLayer);
      this.setLoaded({ dataSource: this.tasksDataSource, value: true });
    },
    async setTasksStyle(style) {
      const { id, geometry_type } = this.tasksLayer;
      const layersArray = this.getLayerById('layers')
        .getLayers()
        .getArray();
      const layer = layersArray.find(layer => layer.get('id') === this.tasksLayerId);
      layer.setStyle(f => this.getFeatureStyle(f, style.style, geometry_type, false, id));
    },
  },
  mounted() {
    this.$root.$on('tasksStyleChanged', this.setTasksStyle);
  },
};
